//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import DrawerComp from "@/components/common/drawer.comp.vue";
import SearchComp from "@/components/common/search.comp.vue";
export default {
  name: "LayoutDefault",
  components: {
    DrawerComp,
    SearchComp
  },
  computed:{
    ...mapActions(['toggelMenu'])
  },
  methods:{
    getLeftDrawer(){
      this.$store.dispatch("toggelMenu")
    }
  },
  mounted(){
    this.$store.dispatch("toggelMenu")
  }
};
